// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/searchIcon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f0f0f7;
}
.logo {
  width: 90px;
  height: 45px;
}
.logo_text {
  color: #000;
}
a {
  color: #333333;
}
.nav-tabs {
  border-bottom: 1px solid #cecece;
}
.nav-tabs {
  border-bottom: 1px solid #cecece;
}
.nav-tabs .nav-link {
  color: black;
}
.nav-tabs .nav-link:focus,
.nav-tabs {
  border-color: F0F0F7 F0F0F7 F0F0F7;
}
.nav-tabs .nav-link.active {
  border-bottom: 2px solid #0072ce !important;
  border-left-color: #f0f0f7 !important;
  border-right-color: #f0f0f7 !important;
  border-top-color: #f0f0f7 !important;
  background-color: #f0f0f7 !important;
  color: #0072ce !important;
  font-weight: 500;
}
.search-position {
  position: absolute;
  top: 8px;
  right: 20px;
}
.text-link {
  border-bottom: 1px solid #427bff;
  color: #427bff !important;
  cursor: pointer;
}
.navbar-fixed-bottom {
  content: "";
  border-top: 0;
  border-bottom: 4px dashed;
  border-bottom: 4px solid\\9;
}
.nav-tabs .nav-link:focus,
.nav-tabs {
  border-color: F0F0F7 F0F0F7 F0F0F7;
}
.react-bootstrap-table-pagination-list {
  display: flex !important;
  justify-content: flex-end !important;
}
table.dataTable thead tr {
  background-color: #e6e7e9;
}

.table thead th {
  background-color: #e6e7e9 !important;
}
#root ._loading_overlay_wrapper {
  position: fixed !important;
  padding-bottom: 150px;
  max-width: 100%;
  overflow-x: hidden;
}
._loading_overlay_wrapper {
  height: 100%;
  width: 100%;
  background-color: #f0f0f7 !important;
  overflow-y: auto;
}
._loading_overlay_spinner.css-50etie {
  width: 100px !important;
}
._loading_overlay_spinner svg circle {
  stroke: #0072ce !important;
  stroke-width: 3 !important;
}
._loading_overlay_wrapper {
  background: none !important;
}
.nav-tabs .nav-link.active {
  border-bottom: 2px solid #0072ce !important;
  border-left-color: #f0f0f7 !important;
  border-right-color: #f0f0f7 !important;
  border-top-color: #f0f0f7 !important;
  background-color: #f0f0f7 !important;
  color: #0072ce !important;
  font-weight: 500;
}
.nav-tabs .nav-link:hover {
  border-bottom: 1px solid #cecece;
}
.profile-icon {
  background-color: grey;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 1.3;
}

.profile-icon-inner {
  background-color: grey;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
  width: 35px;
  height: 35px;
  line-height: 2.3;
  text-align: center;
  vertical-align: middle;
}
.dropdown-item:active {
  background-color: #fff !important;
}
.btn-inner {
  padding: 4px 15px 3px 15px;
  background: #0072ce;
  border: none;
  font-size: 16px;
  border-radius: 2px !important;
}
.btn-inner-disable,
.btn-inner-disable:hover {
  padding: 3px 15px 3px 15px;
  background-color: #c6c6c6;
  color: #767676;
  border: none;
  font-size: 16px;
  border-radius: 2px !important;
  cursor: not-allowed !important;
}

.btn-inner-disable:active,
.btn-inner-disable:focus {
  background-color: #c6c6c6 !important;
  color: #767676 !important;
  cursor: not-allowed !important;
}

.btn-inner-black,
.btn-inner-black:hover {
  padding: 3px 15px 3px 15px;
  background: #414141;
  border: none;
  font-size: 16px;
  color: #fff;
  border-radius: 2px !important;
}
.btn-inner-black:active {
  background: #414141;
}

.btn-go-inner {
  height: 30px;
  background-color: #0072ce;
  padding: 0px 10px 0px 10px;
  border-radius: 0px;
  margin-top: 2px;
}
.btn-success-inner,
.btn-success-inner:hover {
  background-color: #8cc646;
  border: 1px solid #8cc646;
  border-radius: 4px;
  width: 80px;
}
.btn-fail-inner,
.btn-fail-inner:hover {
  background-color: #ff0000;
  border: 1px solid #ff0000;
  border-radius: 4px;
  width: 80px;
}

.custom-form-control {
  height: 32px !important;
  padding-left: 5px !important;
  padding-top: 4px !important;
  border: 1px solid #cecece !important;
  border-radius: 1px !important;
  /* background-color: #fff !important; */
}
.custom-form-control1 {
  width: 50px;
  height: 30px;
  padding: 5px;
  margin-right: 5px;
  border-radius: 0px;
}
.custom-form-control2 {
  width: 60px;
  height: 30px !important;
  padding: 2px;
  margin-right: 5px;
  border-radius: 0px;
}

.form-control:focus {
  outline: 0 !important;
  border-color: initial;
  box-shadow: none;
}

.btn:focus {
  outline: 0 !important;
  border-color: transparent;
  box-shadow: none;
}

.search-input {
  border-top: 1px solid #9ea6a9 !important;
  border-right: 1px solid #9ea6a9 !important;
  border-bottom: 1px solid #9ea6a9;
  border-left: 1px solid #9ea6a9;
  border-radius: 0 !important;
  background-color: #fff;
  padding-left: 4px;
  height: 32px;
  width: 250px;
}
.search-right-inner {
  position: absolute;
  right: 13px;
}
.search-icon {
  position: absolute;
  right: 2px;
  padding-top: 0px !important;
  padding-left: 5px;
  padding-right: 5px;
  height: 25px;
  top: 2px;
  background-color: #fff;
  width: 25px;
  height: 25px;
}
.bg-transparent {
  background-color: transparent !important;
}

.drop-width {
  flex: 0 0 19.666667%;
  max-width: 19.666667%;
}

.panelTitle {
  height: 46px !important;
  background-color: #004267 !important;
  color: #fff !important;
  padding-top: 6px;
}

.panelTitle2 {
  height: 40px !important;
}

.panel-bg {
  background-color: #fff;
}

.modal-open {
  overflow: hidden;
  padding-right: 0 !important;
}
body {
  padding-right: 0 !important;
}

.hiddenRow {
  padding: 0px !important;
  background-color: #eeeeee;
}

.w-40 {
  width: 40px;
}
.w-51 {
  width: 51px;
}
/* Table CSS */
table.dataTable thead tr {
  background-color: #e6e7e9;
}

/* .manage_sub_table tr th {
  padding-bottom: 5px;
  padding-top: 5px;
}

.manage_sub_table tbody > tr > :nth-child(1) {
  width: 5%;
}
.manage_sub_table tbody > tr > :nth-child(2) {
  width: 20%;
} */

.sub_run_table tbody > tr > :nth-child(1) {
  width: 5%;
}
.sub_run_table tbody > tr > :nth-child(2) {
  width: 65%;
}

.sub_run_table tr th {
  padding-top: 8px;
  padding-bottom: 8px;
}
#non_sched_table tbody > tr > :nth-child(1) {
  width: 5%;
}
#non_sched_table tbody > tr > :nth-child(2) {
  width: 30%;
}
#non_sched_table tbody > tr > :nth-child(3) {
  width: 15%;
}
#non_sched_table tbody > tr > :nth-child(4) {
  width: 30%;
}
#non_sched_table tbody > tr > :nth-child(5) {
  width: 10%;
}
.table_history a {
  font-weight: bold;
  color: #0072ce;
}

/* Table CSS */

.icon_circle {
  width: 16px;
  height: 16px;
  padding-bottom: 2px;
}
.icon_actions {
  width: 17px;
  height: 17px;
  cursor: pointer;
}
.icon_quest {
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.expire_text {
  color: #ff0000;
}
.about_expire_text {
  color: #ffa500;
}

/* datepicker */
.datepicker td,
.datepicker th {
  width: 30px;
  height: 30px;
  font-size: 14px;
}

.datepicker {
  margin-bottom: 3rem;
}

.pointer {
  cursor: pointer;
}

.input-group-nbg {
  border: none;
  background-color: transparent;
  padding-top: 2px;
  cursor: pointer;
}

.required-field {
  color: red;
  font-size: 20px;
  line-height: 1;
}
.required-text {
  color: red;
  line-height: 1;
}

a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}

.footer {
  position: fixed;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  height: 45px;
  border-top: 1px solid #f0f0f7;
  justify-content: center;
}

.cert-pad {
  padding-top: 12px;
  padding-right: 5px;
}
.foot-text {
  padding-top: 10px;
}
/* .bg-img::before{
    background-color: rgba(0, 0, 0, 0.7);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    width: 100%;
  } */

/* HSI */

a.nav-link.housename.active {
  border-bottom: 2.5px solid #0072ce !important;
  color: #0072ce;
  font-weight: 500;
}

.nav {
  border-bottom: 1px solid #cecece;
}

.btn-link:hover {
  color: #0056b3;
  text-decoration: none !important;
  background-color: transparent;
  border-color: transparent;
}

.feedbackinput {
  border: none !important;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  color: #0072ce !important;
}

.my-icon {
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("https://use.fontawesome.com/releases/v5.8.2/svgs/regular/calendar-alt.svg");
  background-repeat: no-repeat;
  background-position: 98% calc(0.255em + 0.1rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

#searchclear {
  position: relative;
  float: right;
  right: 5px;
  top: -28px;
  bottom: 0;
  height: 16px;
  margin: auto;
  font-size: 16px;
  cursor: pointer;
  color: #414141;
  z-index: 9999;
}
#searchcleardetail {
  position: relative;
  float: right;
  right: 5px;
  top: -28px;
  bottom: 0;
  height: 16px;
  margin: auto;
  font-size: 16px;
  cursor: pointer;
  color: #414141;
  z-index: 9999;
}
.search-input {
  border-top: 1px solid #9ea6a9 !important;
  border-right: 1px solid #9ea6a9 !important;
  border-bottom: 1px solid #9ea6a9 !important;
  border-left: 1px solid #9ea6a9 !important;
  border-radius: 0 !important;
  background-color: #fff !important;
  padding-left: 4px !important;
  height: 32px !important;
  width: 250px !important;
}
.error-border {
  border: 1px solid red !important;
}
select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 2px);
  width: 13%;
}
.search-input {
  border-top: 1px solid #9ea6a9 !important;
  border-right: 1px solid #9ea6a9 !important;
  border-bottom: 1px solid #9ea6a9 !important;
  border-left: 1px solid #9ea6a9 !important;
  border-radius: 0 !important;
  background-color: #fff !important;
  padding-left: 4px !important;
  height: 32px !important;
  width: 250px !important;
}
.my-search {
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 98% calc(0.2em + 0.1rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

#dpEndDate {
  width: 144px;
}

#customerddl {
  width: 200px;
}

#dpStartDate {
  width: 144px;
}

#affiliatesirn {
  width: 210px;
}

#status {
  width: 150px;
}
#customerddldetail {
  width: 200px;
}

#affiliatesirndetail1 {
  width: 210px;
}
#dpStartDateDetail {
  width: 144px;
}
#dpEndDateDetail {
  width: 144px;
}
.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.dropup,
.dropdown {
  position: relative;
}
.dropup .caret,
.navbar-fixed-bottom .dropdown .caret {
  border-top: 0;
  border-bottom: 4px dashed;
  border-bottom: 4px solid \\9;
  content: "";
}

hr.hrmargin {
  margin-top: 5px;
  margin-bottom: 5px;
}

p.dashboardlabels {
  font-weight: 400;
  margin-bottom: 0px;
  font-size: 15px;
}

p.dashboardlabeldynamicdata {
  color: #0072ce;
  font-weight: 500;
  font-size: 17px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #f0f0f7 !important;
  border-radius: 0.25rem;
}
.page-link1 {
  position: relative;
  display: block;
  padding: 0.5rem 1.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  /* border: 1px solid #dee2e6; */
}

.arrow {
  border: solid #007bff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.modal-header .close {
  padding: 1rem;
  margin: -22px -17px -31px auto;
}

.noborderbottom {
  border-bottom: none !important;
}

.disablebirdlink {
  text-decoration: none !important;
  color: #212529 !important;
  cursor: default !important;
}

.activebirdlink {
  text-decoration: underline !important;
}

.req {
  color: red;
  padding-left: 3px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.background-white {
  background-color: white;
  margin-right: 6px;
  margin-left: 6px;
}

.modal-90w {
  max-width: 60% !important;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
  margin-bottom: 0px !important;
}
.datanotfound {
  left: 0;
  line-height: 47px;
  margin-top: -100px;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  font-size: 25px;
}
.dashboard {
  margin-right: 30px;
  margin-left: 30px;
}

.modal-60w {
  max-width: 70% !important;
}

.background-gray {
  background-color: #f0f0f7;
  margin-right: 6px;
  margin-left: 6px;
}
#customerirn {
  width: 210px;
}

.mb {
  margin-bottom: 4%;
}

button#SummaryReport {
  background-color: white;
}

button#SummaryReport:hover {
  background-color: #007bff;
  color: white;
}
.gigya-screen.portrait {
  width: 90% !important;
  font-size: 15px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-top: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/assests/css/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA,cAAc;AACd;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,cAAc;;AAEd;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;;;;;;KAOK;;AAEL,QAAQ;;AAER;EACE,6CAA6C;EAC7C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,kGAAkG;EAClG,4BAA4B;EAC5B,+CAA+C;EAC/C,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;EACzC,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;EACzC,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,yDAAiD;EACjD,4BAA4B;EAC5B,6CAA6C;EAC7C,gEAAgE;AAClE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":["body {\n  background-color: #f0f0f7;\n}\n.logo {\n  width: 90px;\n  height: 45px;\n}\n.logo_text {\n  color: #000;\n}\na {\n  color: #333333;\n}\n.nav-tabs {\n  border-bottom: 1px solid #cecece;\n}\n.nav-tabs {\n  border-bottom: 1px solid #cecece;\n}\n.nav-tabs .nav-link {\n  color: black;\n}\n.nav-tabs .nav-link:focus,\n.nav-tabs {\n  border-color: F0F0F7 F0F0F7 F0F0F7;\n}\n.nav-tabs .nav-link.active {\n  border-bottom: 2px solid #0072ce !important;\n  border-left-color: #f0f0f7 !important;\n  border-right-color: #f0f0f7 !important;\n  border-top-color: #f0f0f7 !important;\n  background-color: #f0f0f7 !important;\n  color: #0072ce !important;\n  font-weight: 500;\n}\n.search-position {\n  position: absolute;\n  top: 8px;\n  right: 20px;\n}\n.text-link {\n  border-bottom: 1px solid #427bff;\n  color: #427bff !important;\n  cursor: pointer;\n}\n.navbar-fixed-bottom {\n  content: \"\";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid\\9;\n}\n.nav-tabs .nav-link:focus,\n.nav-tabs {\n  border-color: F0F0F7 F0F0F7 F0F0F7;\n}\n.react-bootstrap-table-pagination-list {\n  display: flex !important;\n  justify-content: flex-end !important;\n}\ntable.dataTable thead tr {\n  background-color: #e6e7e9;\n}\n\n.table thead th {\n  background-color: #e6e7e9 !important;\n}\n#root ._loading_overlay_wrapper {\n  position: fixed !important;\n  padding-bottom: 150px;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n._loading_overlay_wrapper {\n  height: 100%;\n  width: 100%;\n  background-color: #f0f0f7 !important;\n  overflow-y: auto;\n}\n._loading_overlay_spinner.css-50etie {\n  width: 100px !important;\n}\n._loading_overlay_spinner svg circle {\n  stroke: #0072ce !important;\n  stroke-width: 3 !important;\n}\n._loading_overlay_wrapper {\n  background: none !important;\n}\n.nav-tabs .nav-link.active {\n  border-bottom: 2px solid #0072ce !important;\n  border-left-color: #f0f0f7 !important;\n  border-right-color: #f0f0f7 !important;\n  border-top-color: #f0f0f7 !important;\n  background-color: #f0f0f7 !important;\n  color: #0072ce !important;\n  font-weight: 500;\n}\n.nav-tabs .nav-link:hover {\n  border-bottom: 1px solid #cecece;\n}\n.profile-icon {\n  background-color: grey;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  text-align: center;\n  line-height: 1.3;\n}\n\n.profile-icon-inner {\n  background-color: grey;\n  border-radius: 50%;\n  margin-right: 10px;\n  display: inline-block;\n  width: 35px;\n  height: 35px;\n  line-height: 2.3;\n  text-align: center;\n  vertical-align: middle;\n}\n.dropdown-item:active {\n  background-color: #fff !important;\n}\n.btn-inner {\n  padding: 4px 15px 3px 15px;\n  background: #0072ce;\n  border: none;\n  font-size: 16px;\n  border-radius: 2px !important;\n}\n.btn-inner-disable,\n.btn-inner-disable:hover {\n  padding: 3px 15px 3px 15px;\n  background-color: #c6c6c6;\n  color: #767676;\n  border: none;\n  font-size: 16px;\n  border-radius: 2px !important;\n  cursor: not-allowed !important;\n}\n\n.btn-inner-disable:active,\n.btn-inner-disable:focus {\n  background-color: #c6c6c6 !important;\n  color: #767676 !important;\n  cursor: not-allowed !important;\n}\n\n.btn-inner-black,\n.btn-inner-black:hover {\n  padding: 3px 15px 3px 15px;\n  background: #414141;\n  border: none;\n  font-size: 16px;\n  color: #fff;\n  border-radius: 2px !important;\n}\n.btn-inner-black:active {\n  background: #414141;\n}\n\n.btn-go-inner {\n  height: 30px;\n  background-color: #0072ce;\n  padding: 0px 10px 0px 10px;\n  border-radius: 0px;\n  margin-top: 2px;\n}\n.btn-success-inner,\n.btn-success-inner:hover {\n  background-color: #8cc646;\n  border: 1px solid #8cc646;\n  border-radius: 4px;\n  width: 80px;\n}\n.btn-fail-inner,\n.btn-fail-inner:hover {\n  background-color: #ff0000;\n  border: 1px solid #ff0000;\n  border-radius: 4px;\n  width: 80px;\n}\n\n.custom-form-control {\n  height: 32px !important;\n  padding-left: 5px !important;\n  padding-top: 4px !important;\n  border: 1px solid #cecece !important;\n  border-radius: 1px !important;\n  /* background-color: #fff !important; */\n}\n.custom-form-control1 {\n  width: 50px;\n  height: 30px;\n  padding: 5px;\n  margin-right: 5px;\n  border-radius: 0px;\n}\n.custom-form-control2 {\n  width: 60px;\n  height: 30px !important;\n  padding: 2px;\n  margin-right: 5px;\n  border-radius: 0px;\n}\n\n.form-control:focus {\n  outline: 0 !important;\n  border-color: initial;\n  box-shadow: none;\n}\n\n.btn:focus {\n  outline: 0 !important;\n  border-color: transparent;\n  box-shadow: none;\n}\n\n.search-input {\n  border-top: 1px solid #9ea6a9 !important;\n  border-right: 1px solid #9ea6a9 !important;\n  border-bottom: 1px solid #9ea6a9;\n  border-left: 1px solid #9ea6a9;\n  border-radius: 0 !important;\n  background-color: #fff;\n  padding-left: 4px;\n  height: 32px;\n  width: 250px;\n}\n.search-right-inner {\n  position: absolute;\n  right: 13px;\n}\n.search-icon {\n  position: absolute;\n  right: 2px;\n  padding-top: 0px !important;\n  padding-left: 5px;\n  padding-right: 5px;\n  height: 25px;\n  top: 2px;\n  background-color: #fff;\n  width: 25px;\n  height: 25px;\n}\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.drop-width {\n  flex: 0 0 19.666667%;\n  max-width: 19.666667%;\n}\n\n.panelTitle {\n  height: 46px !important;\n  background-color: #004267 !important;\n  color: #fff !important;\n  padding-top: 6px;\n}\n\n.panelTitle2 {\n  height: 40px !important;\n}\n\n.panel-bg {\n  background-color: #fff;\n}\n\n.modal-open {\n  overflow: hidden;\n  padding-right: 0 !important;\n}\nbody {\n  padding-right: 0 !important;\n}\n\n.hiddenRow {\n  padding: 0px !important;\n  background-color: #eeeeee;\n}\n\n.w-40 {\n  width: 40px;\n}\n.w-51 {\n  width: 51px;\n}\n/* Table CSS */\ntable.dataTable thead tr {\n  background-color: #e6e7e9;\n}\n\n/* .manage_sub_table tr th {\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n\n.manage_sub_table tbody > tr > :nth-child(1) {\n  width: 5%;\n}\n.manage_sub_table tbody > tr > :nth-child(2) {\n  width: 20%;\n} */\n\n.sub_run_table tbody > tr > :nth-child(1) {\n  width: 5%;\n}\n.sub_run_table tbody > tr > :nth-child(2) {\n  width: 65%;\n}\n\n.sub_run_table tr th {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n#non_sched_table tbody > tr > :nth-child(1) {\n  width: 5%;\n}\n#non_sched_table tbody > tr > :nth-child(2) {\n  width: 30%;\n}\n#non_sched_table tbody > tr > :nth-child(3) {\n  width: 15%;\n}\n#non_sched_table tbody > tr > :nth-child(4) {\n  width: 30%;\n}\n#non_sched_table tbody > tr > :nth-child(5) {\n  width: 10%;\n}\n.table_history a {\n  font-weight: bold;\n  color: #0072ce;\n}\n\n/* Table CSS */\n\n.icon_circle {\n  width: 16px;\n  height: 16px;\n  padding-bottom: 2px;\n}\n.icon_actions {\n  width: 17px;\n  height: 17px;\n  cursor: pointer;\n}\n.icon_quest {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n.expire_text {\n  color: #ff0000;\n}\n.about_expire_text {\n  color: #ffa500;\n}\n\n/* datepicker */\n.datepicker td,\n.datepicker th {\n  width: 30px;\n  height: 30px;\n  font-size: 14px;\n}\n\n.datepicker {\n  margin-bottom: 3rem;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.input-group-nbg {\n  border: none;\n  background-color: transparent;\n  padding-top: 2px;\n  cursor: pointer;\n}\n\n.required-field {\n  color: red;\n  font-size: 20px;\n  line-height: 1;\n}\n.required-text {\n  color: red;\n  line-height: 1;\n}\n\na:hover,\na:focus {\n  text-decoration: none;\n  outline: none;\n}\n\n.footer {\n  position: fixed;\n  bottom: 0;\n  background-color: #fff;\n  width: 100%;\n  height: 45px;\n  border-top: 1px solid #f0f0f7;\n  justify-content: center;\n}\n\n.cert-pad {\n  padding-top: 12px;\n  padding-right: 5px;\n}\n.foot-text {\n  padding-top: 10px;\n}\n/* .bg-img::before{\n    background-color: rgba(0, 0, 0, 0.7);\n    content: '';\n    display: block;\n    height: 100%;\n    position: absolute;\n    width: 100%;\n  } */\n\n/* HSI */\n\na.nav-link.housename.active {\n  border-bottom: 2.5px solid #0072ce !important;\n  color: #0072ce;\n  font-weight: 500;\n}\n\n.nav {\n  border-bottom: 1px solid #cecece;\n}\n\n.btn-link:hover {\n  color: #0056b3;\n  text-decoration: none !important;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.feedbackinput {\n  border: none !important;\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n  color: #0072ce !important;\n}\n\n.my-icon {\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"https://use.fontawesome.com/releases/v5.8.2/svgs/regular/calendar-alt.svg\");\n  background-repeat: no-repeat;\n  background-position: 98% calc(0.255em + 0.1rem);\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n#searchclear {\n  position: relative;\n  float: right;\n  right: 5px;\n  top: -28px;\n  bottom: 0;\n  height: 16px;\n  margin: auto;\n  font-size: 16px;\n  cursor: pointer;\n  color: #414141;\n  z-index: 9999;\n}\n#searchcleardetail {\n  position: relative;\n  float: right;\n  right: 5px;\n  top: -28px;\n  bottom: 0;\n  height: 16px;\n  margin: auto;\n  font-size: 16px;\n  cursor: pointer;\n  color: #414141;\n  z-index: 9999;\n}\n.search-input {\n  border-top: 1px solid #9ea6a9 !important;\n  border-right: 1px solid #9ea6a9 !important;\n  border-bottom: 1px solid #9ea6a9 !important;\n  border-left: 1px solid #9ea6a9 !important;\n  border-radius: 0 !important;\n  background-color: #fff !important;\n  padding-left: 4px !important;\n  height: 32px !important;\n  width: 250px !important;\n}\n.error-border {\n  border: 1px solid red !important;\n}\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.25rem + 2px);\n  width: 13%;\n}\n.search-input {\n  border-top: 1px solid #9ea6a9 !important;\n  border-right: 1px solid #9ea6a9 !important;\n  border-bottom: 1px solid #9ea6a9 !important;\n  border-left: 1px solid #9ea6a9 !important;\n  border-radius: 0 !important;\n  background-color: #fff !important;\n  padding-left: 4px !important;\n  height: 32px !important;\n  width: 250px !important;\n}\n.my-search {\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"../images/searchIcon.svg\");\n  background-repeat: no-repeat;\n  background-position: 98% calc(0.2em + 0.1rem);\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n#dpEndDate {\n  width: 144px;\n}\n\n#customerddl {\n  width: 200px;\n}\n\n#dpStartDate {\n  width: 144px;\n}\n\n#affiliatesirn {\n  width: 210px;\n}\n\n#status {\n  width: 150px;\n}\n#customerddldetail {\n  width: 200px;\n}\n\n#affiliatesirndetail1 {\n  width: 210px;\n}\n#dpStartDateDetail {\n  width: 144px;\n}\n#dpEndDateDetail {\n  width: 144px;\n}\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.dropup,\n.dropdown {\n  position: relative;\n}\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid \\9;\n  content: \"\";\n}\n\nhr.hrmargin {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\np.dashboardlabels {\n  font-weight: 400;\n  margin-bottom: 0px;\n  font-size: 15px;\n}\n\np.dashboardlabeldynamicdata {\n  color: #0072ce;\n  font-weight: 500;\n  font-size: 17px;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #f0f0f7 !important;\n  border-radius: 0.25rem;\n}\n.page-link1 {\n  position: relative;\n  display: block;\n  padding: 0.5rem 1.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  background-color: #fff;\n  /* border: 1px solid #dee2e6; */\n}\n\n.arrow {\n  border: solid #007bff;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 4px;\n}\n\n.right {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.left {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n\n.modal-header .close {\n  padding: 1rem;\n  margin: -22px -17px -31px auto;\n}\n\n.noborderbottom {\n  border-bottom: none !important;\n}\n\n.disablebirdlink {\n  text-decoration: none !important;\n  color: #212529 !important;\n  cursor: default !important;\n}\n\n.activebirdlink {\n  text-decoration: underline !important;\n}\n\n.req {\n  color: red;\n  padding-left: 3px;\n}\n.center {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n.background-white {\n  background-color: white;\n  margin-right: 6px;\n  margin-left: 6px;\n}\n\n.modal-90w {\n  max-width: 60% !important;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n  margin-bottom: 0px !important;\n}\n.datanotfound {\n  left: 0;\n  line-height: 47px;\n  margin-top: -100px;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  width: 100%;\n  font-size: 25px;\n}\n.dashboard {\n  margin-right: 30px;\n  margin-left: 30px;\n}\n\n.modal-60w {\n  max-width: 70% !important;\n}\n\n.background-gray {\n  background-color: #f0f0f7;\n  margin-right: 6px;\n  margin-left: 6px;\n}\n#customerirn {\n  width: 210px;\n}\n\n.mb {\n  margin-bottom: 4%;\n}\n\nbutton#SummaryReport {\n  background-color: white;\n}\n\nbutton#SummaryReport:hover {\n  background-color: #007bff;\n  color: white;\n}\n.gigya-screen.portrait {\n  width: 90% !important;\n  font-size: 15px;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  padding-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
